import type { JsonObject, Override } from '@/app-package';
import type { ListingDoc, OrgDoc } from '@bb/domain/dist/schemas';
import type { User } from '@bb/users';
import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';
import type { ExternalListing } from 'contexts';

// @TODO: Move to @/app-package
export type ExternalListingDTO = JsonObject<{
  listing: Override<ListingDoc, 'reps' | 'org'> & { reps: User[]; org: OrgDoc };
}>;

const isDashboardIdResult = (
  data: ExternalListingDTO | ExternalListing,
): data is ExternalListingDTO => Boolean((data as ExternalListingDTO).listing);

const getExternalListing = async ({
  dashboardId,
  retsId,
  listingId,
}: {
  dashboardId?: string;
  retsId?: string;
  listingId: string;
}) => {
  const config: AxiosRequestConfig = {
    url: dashboardId
      ? `/external/dash/${dashboardId}/listings/${listingId}`
      : `/external/listing/${retsId}`,
    method: 'get',
  };

  const { data } = await axios.request<ExternalListingDTO | ExternalListing>(
    config,
  );

  if (isDashboardIdResult(data)) {
    return data.listing;
  }
  return data;
};

export default getExternalListing;
